import { RoutePaths } from "@/config/route-paths";
import { BreadcrumbsBuilder, type IBreadcrumbItem } from "@cmde/shadcn";
import i18next from "i18next";
import { env } from "@/config/environment-vars";

export class AppBreadcrumbsBuilder extends BreadcrumbsBuilder<IBreadcrumbItem> {
  static start(): AppBreadcrumbsBuilder {
    return new AppBreadcrumbsBuilder();
  }

  withSportradar(): this {
    this.items.push({
      title: i18next.t("breadcrumbs.sportradar"),
      href: "/",
      hintText: i18next.t("breadcrumbs.goToHomepage"),
    });
    return this;
  }

  withStatsAdmin(): this {
    this.items.push({ title: env.VITE_PROJECT_TITLE });
    return this;
  }

  withCustomer({
    customerId,
    customerName,
  }: {
    customerId: number;
    customerName?: string;
  }): this {
    this.items.push({
      title: customerName
        ? `${customerName} :${customerId}`
        : i18next.t("breadcrumbs.customerFallback", { customerId }),
      href: RoutePaths.customers.list(),
      hintText: i18next.t("breadcrumbs.goToCustomers"),
    });
    return this;
  }

  withOrganization({
    customerId,
    organizationId,
    organizationName,
  }: {
    customerId: number;
    organizationId: string;
    organizationName: string;
  }): this {
    this.items.push({
      title: organizationName || i18next.t("breadcrumbs.organizationFallback", { organizationId }),
      href: RoutePaths.organizations.list({ customerId }),
    });
    return this;
  }

  withBreadcrumb(breadcrumb: IBreadcrumbItem): this {
    this.items.push(breadcrumb);
    return this;
  }

  build() {
    return this.items;
  }
}

export { AppBreadcrumbsBuilder as BreadcrumbsBuilder };
